import { useKeycloak } from "@react-keycloak/web";
import { Suspense } from "react";
import { AuthProvider } from "../../context/auth.context";
import { TransactionProvider } from "../../context/_transaction.context";
import { TransactionServerSideProvider } from "../../context/transactionServerSide.context";
import { VendingProvider } from "../../context/vending.context";
import useKeycloakData from "../../hooks/useKeycloakData";

import { DevicesProvider } from "../../context/devices.context";
import { ExportProvider } from "../../context/export.context";
import { MapProvider } from "../../context/map.context";
import { OnboardingProvider } from "../../context/onboarding.context";
import { CampaignProvider } from "../../context/campaign.context";
import { DateProvider } from "../../context/date.context";
import { POSProvider } from "../../context/pos.context";

import Loader from "../../layouts/Loader/Loader";
import DashboardRoutes from "./DashboardRoutes";

import { VendingFilterProvider } from "../../context/vending.filter.context";
import DashboardLayout from "../../layouts/DashboardLayout";
import { ReporterProvider } from "../../context/reporting.context";
import { ServerSidePagingProvider } from "../../context/ssp.context";

export default function DashboardApp() {
  const { initialized } = useKeycloak();

  const { firstName, lastName } = useKeycloakData();
  const currentUser = { firstName, lastName };

  if (!initialized) {
    return <Loader />;
  }

  return (
    <Suspense fallback={<DashboardLayout />}>
      <TransactionServerSideProvider>
        {/* <TransactionProvider> */}
        <MapProvider>
          <VendingProvider>
            <ExportProvider>
              <ReporterProvider>
                <VendingFilterProvider>
                  <OnboardingProvider>
                    <CampaignProvider>
                      <POSProvider>
                        <DevicesProvider>
                          <AuthProvider user={currentUser}>
                            <DateProvider>
                              <ServerSidePagingProvider>
                                <DashboardRoutes baseUri={`${process.env.PUBLIC_URL}`} />
                              </ServerSidePagingProvider>
                            </DateProvider>
                          </AuthProvider>
                        </DevicesProvider>
                      </POSProvider>
                    </CampaignProvider>
                  </OnboardingProvider>
                </VendingFilterProvider>
              </ReporterProvider>
            </ExportProvider>
          </VendingProvider>
        </MapProvider>
        {/*  </TransactionProvider> */}
      </TransactionServerSideProvider>
    </Suspense>
  );
}
